'use strict';
(function () {
  var _controller = 'newClub.controller';
  angular.module('pentaApp').controller(_controller, controller);
  controller.$inject = ['$scope', '$q', '$injector', 'clubBenefit.resource', 'clubRules.resource', 'image.resource'];
  function controller($scope, $q, $injector, clubBenefitResource, clubRulesResource, imageResource) {
    var clubAddPoints = $scope.$root.employeeApp ? null : $injector.get('clubAddPoints.resource')
    var pointsResource = $scope.$root.employeeApp ? $injector.get('point.resource') : $injector.get('points.resource')

    /// METHODS
    $scope.imageResource = imageResource;
    $scope.selectPoint = selectPoint;
    $scope.redeem = redeem;
    $scope.addGuid = addGuid;

    /// VARS
    $scope.active = "ADD"
    $scope.points = []; //- tipo de puntos
    $scope.rulesDataAdd = []; //- reglas para sumar. tab ADD
    $scope.rulesDataOut = []; //- reglas para canjear. tab EXCHANGE
    $scope.historyData = []; //- historial. tab HISTORY
    // $scope.employeeApp = $scope.$root.employeeApp; //- DESCOMENTAR PARA ACTIVAR LOS CHEVRON DEL CAROUSELL
    var allBenefits = []; //- todos los beneficios
    var allRules = []; //- todas las reglas
    var pointsFilter = {
      list: $scope.$root.employeeApp ? undefined : true,
      enterarse: $scope.$root.employeeApp ? undefined : window.enterprise,
      _controller: _controller,
      _select: ['*']
    }
    var rulesDataFilter = {
      userType: $scope.$root.employeeApp ? 'EMPLOYEE' : 'CLIENT',
      _controller: _controller,
      _select: ['*']
    }
    // WATCHERS
    $scope.$on('$destroy', onDestroy);

    /// INIT
    refresh();
    if (!$scope.$root.employeeApp && !profile._id) {
      $injector.get('bottomLogin.modal').open({ title: i18next.t('Debes iniciar sesión') })
    }

    /////////////////////
    function refresh() {
      var points = pointsResource.query(pointsFilter)
      var benefits = clubBenefitResource.query({ _select: ['*'], _controller: _controller })
      var rulesData = clubRulesResource.query(rulesDataFilter)

      $q
        .all([points.$promise, benefits.$promise, rulesData.$promise])
        .then(function () {
          //- Reglas
          allRules = rulesData;
          //- Points
          $scope.points = points.filter(function (point) { //- filtro de tipos de punto que tengan reglas de salida
            return !!allRules.find(function (f) { return (f.point === point._id && f.direction === 'OUT') });
          });
          if ($scope.points.length) setArrays($scope.points[0]._id) //- obtener arrays necesarios para points[0]
          if ($scope.points.length) $scope.points.forEach(applyPointStyle); //- aplicar estilo a cada tipo de punto
          //- Beneficios
          allBenefits = benefits;
          //- obtener puntos totales de cada tipo de punto
          getTotalPoints(allBenefits);
          if (!$scope.points.length) return
          setArrays($scope.points[0]._id)
        })
        .then(function () {
          setTimeout(function () {
            //- set badge de carrusel position points[0]
            document.querySelectorAll('.indicators')[0].style.backgroundColor = "#3D86FF";
          }, 500)
        })
        .catch(function (err) { if (err) throw new PentaError(err) })
      //- carrusel badges inicio
    }

    function onDestroy() {
      $scope.$root.abortRequests(_controller);
    }

    function applyPointStyle(point) {
      //- text color
      if (point.pwaDesign && point.pwaDesign.textColor) point._styleText = { color: point.pwaDesign.textColor };

      //- background
      if (!point.inAppBackgroundMode || (point.inAppBackgroundMode && !point.pwaDesign || !point.pwaDesign.background)) return point._style = { background: "url(/frontend/static/img/fondowallet.jpg)", "background-repeat": "repeat" }
      if (point.inAppBackgroundMode === 'REPEAT') return point._styleBackground = {
        background: "url(/api/image?_file=image&_id=" + point.pwaDesign.background + ")",
        "background-repeat": "repeat"
      }
      if (point.inAppBackgroundMode === 'CONTAIN') return point._styleBackground = {
        background: "url(/api/image?_file=image&_id=" + point.pwaDesign.background + ")",
        "background-size": "contain",
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-color": "dimgrey"
      }
      if (point.inAppBackgroundMode === 'COVER') return point._styleBackground = {
        background: "url(/api/image?_file=image&_id=" + point.pwaDesign.background + ")",
        "background-size": "cover"
      }
    }

    //- selecciona el tipo de punto activo en carrusel
    function selectPoint($event) {
      //- badges
      document.querySelectorAll('.indicators')[$event.lastActiveIndex].style.backgroundColor = "#EAEAEA";
      document.querySelectorAll('.indicators')[$event.activeIndex].style.backgroundColor = "#3D86FF";
      //- obtener arrays en base al tipo de punto seleccionado
      setArrays($scope.points[$event.activeIndex]._id)
    }

    //- obtener arrays necesarios para cada tipo de punto
    function setArrays(point) {
      if (!point) return console.error("ERR_AL_GENERAR_ARRAYS")
      //- reglas para sumar. tab ADD 
      $scope.rulesDataAdd = allRules.filter(function (f) { return (f.point === point && f.direction === 'IN') });
      //- reglas para canjear. tab EXCHANGE
      $scope.rulesDataOut = allRules.filter(function (f) { return (f.point === point && f.direction === 'OUT') });
      //- historial. tab HISTORY
      $scope.historyData = allBenefits.filter(function (f) { return (f.content.type === 'POINT' && f.content.point === point) })
      $scope.nextBenefitToExipire = $scope.historyData.filter(function (f) { if (f.expireAt) f.expireAt = new Date(f.expireAt); return !!f.expireAt })
        .sort(function (a, b) { return a.expireAt - b.expireAt })[0];

    }

    //- obtener puntos totales de cada tipo de punto
    function getTotalPoints(data) {
      if (!data.length) return console.error("ERR_AL_OBTENER_TOTAL_DE_PUNTOS")
      $scope.points.forEach(function (f) {
        f._totalPoints = data.reduce(function (total, benefit) {
          if (!benefit.content || benefit.content.type !== 'POINT' || benefit.content.point !== f._id) return total
          return total + (benefit.content.amount || 0)
        }, 0)
      })
    }

    function redeem(clubRule) {
      ons.notification.confirm({ message: i18next.t('¿Seguro que deseas canjear?'), title: 'Confirmación' }).then(function (result) {
        if (!result) return;
        clubRulesResource.save({ clubRule: clubRule._id }, function () {
          ons.notification.alert({
            title: i18next.t('¡Listo!'),
            message: i18next.t('Beneficios canjeados con éxito! Verifica la seccion Vouchers')
          }).then(function () {
            refresh();
          })
        })
      })
    }

    function addGuid(rule) {
      if (!clubAddPoints) throw new PentaError('LOS_EMPLEADOS_NO_PUEDEN_SUMAR_POR_TICKET')
      ons.notification.prompt({
        inputType: 'number',
        title: i18next.t('Cargar ticket'),
        message: i18next.t('Ingrese el código que se encuentra al pie del ticket como GUID')
      }).then(function (result) {
        if (!result) return;
        clubAddPoints.save({
          rule: rule._id,
          origin: rule.origin,
          guid: result
        }, function (result) {
          if (!result.benefits || !result.benefits.length) throw new PentaError('No se pudo obtener el resumen de lo cargado, revise el historial')
          var pointsAdded = result.benefits.filter(function (f) { return f.content.point === rule.point })
            .reduce(function (acc, r) { return acc += (r.content.amount || 0) }, 0)
          ons.notification.alert({ title: i18next.t('Puntos sumados'), message: i18next.t('Puntos sumados correctamente') + ': ' + Math.floor(pointsAdded) })
          refresh();
        })
      })

    }
    //// FIN CONTROLLER
  }
})();
